#import "../fragments/filtered-invoice-fragment.graphql"
query GetFilteredInvoices($input: InvoicesSearchInput!) {
    invoices: invoicesSearch(input: $input) {
        edges {
            node {
                ...FilteredInvoiceFragment
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        totalCount
    }
}
